import {Select} from '@mantine/core';
import {useQuery} from '@tanstack/react-query';
import {fetchRecords} from '../../payment-methods/services/PaymentMethodsService';

interface PaymentMethodSelectorProps {
    value: string | null;
    onChange: (paymentMethodId: string | null) => void;
    customerId: string | null;
}

export const PaymentMethodSelector = ({value, onChange, customerId}: PaymentMethodSelectorProps) => {
    const {data, isLoading} = useQuery({
        queryKey: ['payment-methods-selector', customerId],
        queryFn: () => fetchRecords({customerId}, 100),
        enabled: !!customerId,
    });

    const options = (data?.items || []).map(pm => ({
        value: pm.id,
        label: pm.card
            ? `${pm.card.brand} ****${pm.card.last4} (${pm.card.expMonth}/${pm.card.expYear})`
            : pm.id,
    }));

    return (
        <Select
            label="Payment Method"
            placeholder={!customerId ? 'Select a customer first' : isLoading ? 'Loading...' : 'Select a payment method'}
            data={options}
            value={value}
            onChange={onChange}
            searchable
            disabled={!customerId || isLoading}
        />
    );
};
